export { SidePanel } from './SidePanel'
export type { SidePanelProps, SidePanelSize } from './SidePanel'
export { SIDE_PANEL_WIDTHS, COLLAPSED_WIDTH } from './SidePanel.styles'
